import React from 'react';
import ListItem from 'components/ListItem';
import { FertilizerJustification } from 'services/fertilizerEvents/types';

export interface OwnProps {
    justification?: FertilizerJustification;
}

type Props = OwnProps;

export default function SummaryApplicationJustification(
    props: Props
): React.ReactElement | null {
    const { justification } = props;

    if (!justification) {
        return null;
    }

    return (
        <ListItem
            description="Justification"
            value={justification}
        />
    );
}
